import React from "react";

function VendasTurnoPDV({ reportData }) {
  reportData.forEach((pdv) => {
    pdv.totais = pdv.vendas.reduce(
      (acc, produto) => {
        acc.total += produto.TOTAL ?? 0;
        acc.qtde += produto.QTDE ?? 0;
        acc.comissao += produto.COMISSAO ?? 0;

        return acc;
      },
      { total: 0, qtde: 0, comissao: 0 }
    );
  });

  return (
    <div className="grid box-border gap-12 p-4 w-full grid-cols-1">
      {reportData.map((pdv) => (
        <div
          key={pdv?.CODPDV}
          className="box-border rounded-lg shadow-lg p-4 gap-4 w-full max-w-full"
        >
          <div className="grid gap-2 text-center text-sm sm:text-base">
            <h2 className="font-Oswald text-lg sm:text-xl">{pdv?.CODPDV}</h2>
            <p>
              Turno: {pdv?.TURNO} {" | "}
              Responsável: {pdv?.RESPONSAVEL} {" | "}
              Abertura:{" "}
              {pdv?.ABERTURA
                ? new Date(pdv?.ABERTURA).toLocaleDateString("pt-BR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    timeZone: "UTC",
                  })
                : "-"}
              {" | "}
              Fechamento:{" "}
              {pdv?.FECHAMENTO
                ? new Date(pdv?.FECHAMENTO).toLocaleDateString("pt-BR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    timeZone: "UTC",
                  })
                : "-"}
            </p>
          </div>

          <h3 className="text-center font-Oswald">Produtos</h3>
          <div className="box-border overflow-x-auto w-full mt-4">
            <table className="min-w-full whitespace-nowrap border border-gray-300 text-xs sm:text-sm">
              <thead className="bg-gray-300">
                <tr>
                  <th className="font-Roboto px-4 py-2 border-b text-left font-semibold w-1/2">
                    Produto
                  </th>
                  <th className="font-Roboto px-4 py-2 border-b text-right font-semibold w-1/6">
                    Quantidade
                  </th>
                  <th className="font-Roboto px-4 py-2 border-b text-right font-semibold w-1/6">
                    Comissão
                  </th>
                  <th className="font-Roboto px-4 py-2 border-b text-right font-semibold w-1/6">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {pdv.vendas.map((row, index) => (
                  <tr
                    key={row?.DESCRICAO + index}
                    className="hover:bg-gray-100"
                  >
                    <td className="px-4 py-2 border-b">
                      {row.CODPROD} - {row.DESCRICAO}
                    </td>
                    <td className="px-4 py-2 border-b text-right">
                      {row.QTDE}
                    </td>
                    <td className="px-4 py-2 border-b text-right">
                      {Number(row.COMISSAO).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </td>
                    <td className="px-4 py-2 border-b text-right">
                      {Number(row.TOTAL).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="bg-gray-200 font-semibold">
                  <td className="px-4 py-2 border-b">Total</td>
                  <td className="px-4 py-2 border-b text-right">
                    {pdv.totais.qtde}
                  </td>
                  <td className="px-4 py-2 border-b text-right">
                    {pdv.totais?.comissao?.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </td>
                  <td className="px-4 py-2 border-b text-right">
                    {pdv.totais?.total?.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <h3 className="text-center font-Oswald">Formas de Pagamento</h3>

          <div className="box-border overflow-x-auto w-full mt-4">
            <table className="min-w-full whitespace-nowrap border border-gray-300 text-xs sm:text-sm">
              <thead className="bg-gray-300">
                <tr>
                  <th className="font-Roboto px-4 py-2 border-b text-left font-semibold w-1/6">
                    Forma de Pagamento
                  </th>
                  <th className="font-Roboto px-4 py-2 border-b text-right font-semibold w-1/6">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {pdv.formasPagamento.map((row) => (
                  <tr key={row?.CODFORMAPGTO} className="hover:bg-gray-100">
                    <td className="px-4 py-2 border-b">
                      {row.CODFORMAPGTO} - {row.DESCFORMAPGTO}
                    </td>

                    <td className="px-4 py-2 border-b text-right">
                      {Number(row.TOTAL).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
}

export default VendasTurnoPDV;
